module.exports = __webpack_public_path__ + "img/pilot.816f8b9a.svg";